import React from "react";

/**
 * Vendor Invoice Table Skeleton Loader
 * Provides skeleton loading state for the vendor invoice table during initial data fetch
 * Based on the invoices page skeleton loader design
 */
export const VendorInvoiceTableSkeleton = ({ rows = 10, showVendorColumn = true }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={`vendor-invoice-skeleton-${index}`}>
          {/* Invoice ID */}
          <td className="fixed-sec1" style={{ paddingRight: "44px" }}>
            <div
              style={{
                width: "80px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Vendor Name (conditional) */}
          {showVendorColumn && (
            <td className="fixed-se11" style={{ paddingRight: "35px", maxWidth: "230px", minWidth: "230px", width: "230px" }}>
              <div
                style={{
                  width: "120px",
                  height: "16px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </td>
          )}
          
          {/* CTA column */}
          <td className="fixed-sec21" style={{ paddingRight: "45px", minWidth: "121.73px" }}>
            <div
              style={{
                width: "60px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Due Date */}
          <td className="fixed-sec31" style={{ paddingRight: "44px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Amount */}
          <td className="amount-bold" style={{ paddingRight: "44px" }}>
            <div
              style={{
                width: "90px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Issue Date */}
          <td className="fixed-sec31" style={{ paddingRight: "44px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Created By */}
          <td style={{ paddingRight: "44px", maxWidth: "230px", minWidth: "230px", width: "230px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "50%",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
              <div
                style={{
                  width: "100px",
                  height: "16px",
                  backgroundColor: "#e5e7eb",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />
            </div>
          </td>
          
          {/* Status */}
          <td className="fixed-sec41" style={{ paddingRight: "44px" }}>
            <div
              style={{
                width: "80px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Payment Status */}
          <td style={{ paddingRight: "44px" }}>
            <div
              style={{
                width: "100px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
          
          {/* Payment Date */}
          <td style={{ paddingRight: "44px" }}>
            <div
              style={{
                width: "100px",
                height: "20px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </td>
        </tr>
      ))}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

